import styled from 'styled-components';

import { mediaConfined, mediaWide } from '@xing-com/layout-tokens';
import {
  scale060,
  scale070,
  scale080,
  scale110,
  scale310,
  scale350,
  xdlColorBackgroundSecondary,
  xdlColorPremiumTertiary,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const StyledCard = styled.div`
  background: ${xdlColorBackgroundSecondary};
  display: flex;
  flex-direction: column;

  @media ${mediaConfined} {
    flex-direction: column;
    height: 100%;
  }
`;

export const StyledImageWrap = styled.div`
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;

  display: block;
  width: 100%;
  height: 50vw;
  margin-bottom: ${scale080};
  flex: 0 0 auto;

  @media ${mediaConfined} {
    width: 100%;
    height: ${scale310};
    margin-right: 0;
  }

  @media ${mediaWide} {
    height: ${scale350};
  }
`;

export const StyledImage = styled.img`
  display: none;
`;

export const StyledBodyContainer = styled.div`
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
`;

export const StyledBody = styled.div`
  flex-grow: 1;
  display: flex;
  width: 100%;
  flex-flow: column;
  justify-content: space-between;
`;

export const StyledContent = styled.div`
  padding: 0 ${scale080} ${scale080} ${scale080};
  margin-left: 0;

  @media ${mediaConfined} {
    margin-left: 0;
  }

  @media ${mediaConfined} {
    padding: ${scale070} ${scale080} ${scale110} ${scale080};
  }

  & > * {
    width: 100%;
  }
`;
export const StyledHeadline = styled(Headline)`
  min-height: initial;
  margin-bottom: ${scale060};
`;

export const StyledBodyCopy = styled(BodyCopy)`
  width: 100%;
`;

export const StyledDirectCta = styled.a`
  background-color: ${xdlColorPremiumTertiary};
  display: block;
`;

export const Styled = {
  StyledBody,
  StyledBodyContainer,
  StyledBodyCopy,
  StyledContent,
  StyledCard,
  StyledDirectCta,
  StyledHeadline,
  StyledImageWrap,
  StyledImage,
};
